
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAlertDetailPage as ObcAlertDetailPageElement} from '@oicl/openbridge-webcomponents/dist/pages/alert-detail-page/alert-detail-page.js';
 
 
 

 
 export const ObcAlertDetailPage = createComponent({
   react: React,
   tagName: 'obc-alert-detail-page',
   elementClass: ObcAlertDetailPageElement,
   events: {
     
   }
  });
 
 